export class WidgetState {
    id?: number;
    selector?: string;
    height?: number;
    width?: number;
    left?: number;
    top?: number;
    maximized?: boolean;
}
